import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

/**
 * Quando esta reserva combinou de cobrar. NULL = segue o padrão da clínica, que
 * é cobrar na entrada. Só o hotel usa a escolha por reserva.
 */
export function useReservationBillingTiming(reservationId: string | null) {
  return useQuery({
    queryKey: ["daycare-hotel", "reservation-billing-timing", reservationId],
    enabled: Boolean(reservationId),
    queryFn: async (): Promise<"check_in" | "check_out" | null> => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { data, error } = await (supabase as any)
        .from("stay_reservations")
        .select("billing_timing")
        .eq("id", reservationId)
        .maybeSingle();
      if (error) throw error;
      return data?.billing_timing === "check_out" ? "check_out" : data?.billing_timing === "check_in" ? "check_in" : null;
    },
  });
}
